/* istanbul ignore file -- remove once added tests */
import clsx from "clsx";
import styles from "./BlurredIconTile.module.css";
export function BlurredIconTile({ iconUrl, size = "small", hideIconOverlay, iconBorder, alt, children, }) {
    const containerStyles = clsx([styles.container], {
        [styles.containerLarge]: size === "large",
    });
    function getImage(style) {
        return <img className={style} src={iconUrl} alt={alt}/>;
    }
    return (<div className={containerStyles}>
      <div className={styles.blurredImageContainer}>{getImage(styles.blurredImage)}</div>
      {!hideIconOverlay && (<div className={styles.iconContainer}>
          {iconBorder ? (<div className={styles.iconRadiusContainer}>{getImage(styles.iconRadius)}</div>) : (getImage(styles.icon))}
        </div>)}
      {children}
    </div>);
}
